/* Small deterministic adapter over Shopify's native search and server-side filters. */
((root,factory)=>{const api=factory();if(typeof module==='object'&&module.exports)module.exports=api;else{root.AryaSearch=api;api.install(root);}})(typeof window==='object'?window:this,()=>{
 'use strict';
 const fold=s=>String(s||'').normalize('NFKC').replace(/[\u064B-\u065F\u0670\u0640]/g,'').replace(/[أإآٱ]/g,'ا').replace(/ى/g,'ي').replace(/ة/g,'ه').replace(/[٠-٩۰-۹]/g,c=>String(c.charCodeAt(0)-(c<='٩'?1632:1776))).toLowerCase();
 const aliases=[['Tapo',['تابو','طابو']],['Imou',['ايمو','آيمو']],['EZVIZ',['ايزيفيز','إيزيفيز','ايزي فيز','ايزيفز']],['Akubela',['اكوابيلا','أكوابيلا','اكوبلا','اكوبيلا']],['Tiandy',['تياندي','تياندى','تي اند دي']],['DSPPA',['ديسبا','دي اس بي بي اي']],['TP-Link',['تي بي لينك','تيبي لينك']],['Ubiquiti',['يوبيكويتي','يوبيكويتي']],['Wi-Fi',['واي فاي','وايفاي','واي-فاي']]];
 const plan=raw=>{
  const original=String(raw||'').trim().slice(0,240);let query=original;const filters={};
  // Advanced queries retain their explicit syntax; no fuzzy numeric/model correction.
  if(!original||/[:"<>]/.test(original))return{original,query,filters,changed:false};
  aliases.forEach(([canonical,variants])=>{variants.forEach(alias=>{
   const a=fold(alias),words=query.split(/(\s+)/);for(let i=0;i<words.length;i++){
    for(let n=1;n<=5&&i+n<=words.length;n+=2){if(fold(words.slice(i,i+n).join(''))===a){words.splice(i,n,canonical);break;}}
   }query=words.join('');
  });});
  const negative=fold(query).replace(/بدون (?:اي )?(?:اسلاك|تمديدات)|\bwithout (?:any )?wires\b/g,'');
  if(/بدون|\bwithout\b|\bno\b|\bnot\b/.test(negative))return{original,query,filters,changed:query!==original};
  let t=fold(query).replace(/[‐‑–—-]/g,' ');const strip=patterns=>{patterns.forEach(p=>{t=t.replace(p,' ');});};
  const camera=/كامير[اه]ت?|كامرات|كاميرات|كامره|كميرا|\bcameras?\b/.test(t);
  if(camera){
   filters.product_family='camera';
   const wireFree=/بدون (?:اي )?(?:اسلاك|تمديدات)|\bwire\s*free\b|\bwithout (?:any )?wires\b/.test(t);
   const solar=/طاقه شمسيه|سولر|\bsolar\b/.test(t);
   const battery=/بطاري[اه]ت?|\bbatter(?:y|ies)\b/.test(t);
   const poe=/\bpoe\b/.test(t);
   if(wireFree){filters.power_sources='battery,solar';filters.connectivity='wifi,cellular';}
   if(solar)filters.power_sources='solar';else if(battery)filters.power_sources='battery';else if(poe){filters.power_sources='poe';filters.connectivity='ethernet';}
   if(/\bwi\s*fi\b|\bwifi\b/.test(t))filters.connectivity='wifi';
   if(/ايثرنت|اثرنت|\bethernet\b/.test(t))filters.connectivity='ethernet';
   if(/\b4g\b|\bcellular\b/.test(t))filters.connectivity='cellular';
   if(/خارجي[ه]?|\boutdoor\b/.test(t))filters.use_locations='outdoor';
   else if(/داخلي[ه]?|\bindoor\b/.test(t))filters.use_locations='indoor';
   // Leave model numbers and brand text intact. Terms represented by filters need not match prose.
   strip([/كامير[اه]ت?|كامرات|كاميرات|كامره|كميرا|\bcameras?\b/g,/بدون (?:اي )?(?:اسلاك|تمديدات)|\bwire\s*free\b|\bwithout (?:any )?wires\b/g,/طاقه شمسيه|سولر|\bsolar\b|بطاري[اه]ت?|\bbatter(?:y|ies)\b/g,/خارجي[ه]?|داخلي[ه]?|\boutdoor\b|\bindoor\b/g,/ايثرنت|اثرنت|\bethernet\b|\bwi\s*fi\b|\bwifi\b|\b4g\b|\bcellular\b|\bpoe\b/g]);
   query=t.replace(/\s+/g,' ').trim()||'*';
  }
  return{original,query,filters,changed:query!==original||Object.keys(filters).length>0};
 };
 const build=(raw,action='https://arya.com.kw/search')=>{
  const p=plan(raw),url=new URL(action,'https://arya.com.kw');
  url.searchParams.set('q',p.query);url.searchParams.set('type','product');url.searchParams.delete('page');
  Object.entries(p.filters).forEach(([key,value])=>url.searchParams.set('filter.p.m.arya.'+key,value));
  if(p.changed){url.searchParams.set('arya_q',p.original);url.searchParams.set('arya_intent','1');}
  // Shopify splits multi-value filters before URL decoding. Preserve their comma delimiter.
  url.search=url.search.replace(/%2C/gi,',');
  return url;
 };
 const install=win=>{
  const doc=win.document;
  const initial=new URL(win.location.href);
  if(initial.pathname.endsWith('/search')&&!initial.searchParams.has('arya_intent')&&plan(initial.searchParams.get('q')).changed){
   const url=build(initial.searchParams.get('q'),initial.href);win.location.replace(url.pathname+url.search);return;
  }
  doc.addEventListener('submit',event=>{
   const form=event.target;if(!(form instanceof win.HTMLFormElement))return;
   const input=form.querySelector('[name="q"]');if(!input)return;
   const action=new URL(form.action,win.location.href);if(action.origin!==win.location.origin||!action.pathname.endsWith('/search'))return;
   const p=plan(input.value);if(!p.changed)return;
   event.preventDefault();event.stopImmediatePropagation();
   const url=build(input.value,action.href);win.location.assign(url.pathname+url.search);
  },true);
  const restore=()=>{
   const url=new URL(win.location.href),original=url.searchParams.get('arya_q');
   if(!url.pathname.endsWith('/search')||!original)return;
   doc.querySelectorAll('form[action$="/search"] [name="q"]').forEach(input=>{input.value=original;});
  };
  if(doc.readyState==='loading')doc.addEventListener('DOMContentLoaded',restore,{once:true});else restore();
 };
 return{plan,build,install};
});
